



























































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import LanguageGroup from '@/models/language/languageGroup/languageGroup.model';
import GenericEdit from '@/core/Generics/GenericEdit';
@Component
export default class LanguageGroupEdit extends GenericEdit<LanguageGroup> {
  constructor() {
    super();
    this.controller = 'LanguageGroups';
    this.model = new LanguageGroup();
  }

   saveAll(){
      this.model.languageId = this.$route.params.languageId as any;
      return this.validate();
  }
}
